import { RESET_VALUES } from '../actionTypes';
import { panelLayoutV2Actions } from '../reducer';

export default () => panelLayoutV2Actions[RESET_VALUES]();
